export default __webpack_public_path__ + "static/plaka-beach-d1a77f2bd3637b467adcf50f1a8519d3.jpg";